import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { authwsEnvironment } from '../authws-environment';

const requestSchema = z.object({
  email: z.string(),
  token: z.string(),
  password: z.string(),
  alias: z.string().optional(),
  forceChangeOnNextLogin: z.boolean(),
});

/**
 * Use a password reset token to change a user's password
 * @param email user email
 * @param token password reset token
 * @param password new password
 * @param alias account alias (Optional)
 * @param forceChangeOnNextLogin force user to change password on next login
 */
export function postPasswordResetChange(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return fromFetch(
    new Request(`${authwsEnvironment.resolve(this).passwordResetUrl}/change`, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(ignoreData());
}
